<template>
  <div class="terms-form">
    <div class="mb-0">
      <div
        class="checkbox"
        :class="{ 'has-errors': hasErrors('privacy_and_terms') }"
      >
        <label>
          <input
            v-model="form.privacy_and_terms"
            :class="{ 'has-errors': hasErrors('privacy_and_terms') }"
            type="checkbox"
          />
          <span>
            * I have read and accept the
            <a class="text-yellow" href="/privacy-policy" target="blank_pp">
              Privacy Policy
            </a>
            and the
            <a class="text-yellow" href="/terms" target="blank_terms">
              Terms of Use </a
            >. I am authorized to sign such documents.
          </span>
        </label>
      </div>
      <p v-if="hasErrors('privacy_and_terms')" class="text-danger">
        {{ error }}
      </p>
    </div>

    <div class="mb-0">
      <div
        class="checkbox"
        :class="{ 'has-errors': hasErrors('personal_data') }"
      >
        <label>
          <input
            v-model="form.personal_data"
            :class="{ 'has-errors': hasErrors('personal_data') }"
            type="checkbox"
          />
          <span>
            * I agree to store and process my personal data for the purposes of
            providing and successful execution of Vestbee services including
            matching with third parties, eg. introduction to third parties.
          </span>
        </label>
      </div>
      <p v-if="hasErrors('personal_data')" class="text-danger">
        {{ error }}
      </p>
    </div>

    <div class="mb-0">
      <div
        class="checkbox"
        :class="{ 'has-errors': hasErrors('personal_data_communication') }"
      >
        <label>
          <input
            v-model="form.personal_data_communication"
            :class="{ 'has-errors': hasErrors('personal_data_communication') }"
            type="checkbox"
          />
          <span>
            * I agree my personal data will be stored and processed for the
            purposes of online communication.
          </span>
        </label>
      </div>
      <p v-if="hasErrors('personal_data_communication')" class="text-danger">
        {{ error }}
      </p>
    </div>

    <p class="text-xs text-muted">
      Point (a) Art. 6(1) and the content of the General Data Protection
      Regulation ...
      <a
        class="text-yellow"
        href
        target="blank"
        @click.prevent="showGdprText()"
      >
        read more
      </a>
    </p>
  </div>
</template>

<script>
import { reactive, watch } from '@vue/composition-api'

export default {
  props: {
    showErrors: {
      type: Boolean,
      default: false,
    },
    markAll: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root, emit }) {
    const form = reactive({
      privacy_and_terms: false,
      personal_data: false,
      personal_data_communication: false,
    })

    if (props.markAll) {
      form.privacy_and_terms = true
      form.personal_data = true
      form.personal_data_communication = true
    }

    const areAllInputsChecked = () => {
      return (
        form.privacy_and_terms &&
        form.personal_data &&
        form.personal_data_communication
      )
    }

    watch(areAllInputsChecked, (val) => {
      emit('update:all-terms-accepted', val)
    })

    const hasErrors = (key) => {
      return props.showErrors && !form[key]
    }

    const showGdprText = () => {
      const content = getGdprText()
        .map((p) => `<p>${p}</p>`)
        .join('\n')
      root
        .$alert(content, '', {
          dangerouslyUseHTMLString: true,
        })
        .catch(() => {})
    }
    return {
      form,
      hasErrors,
      showGdprText,
      error: 'This field must be checked',
    }
  },
}

function getGdprText() {
  return [
    'Point (a) Art. 6(1) and the content of the General Data Protection Regulation are the basis for the processing of personal data provided. According to Art 13 (1) and (2) of the General Data Protection Regulation of 27 April 2016 we hereby inform that the administrator of your personal data collected via www.vestbee.com will be Vestbee Sp. z o.o, with registered office at ul. Padewska 23/7, 00-077 Warsaw, Poland, mail: office@vestbee.com. The personal data provided will be stored as long as you will remain a user of Vestbee. The provision of data is voluntary, but necessary for use of Vestbee platform.',
    'You have the right to request from the controller access to your personal data, as well as rectification or erasure of data provided or restriction of processing or to object to processing as well as the right to data portability. You also have the right to withdraw consent at any time, without affecting the lawfulness of processing based on consent before its withdrawal.',
    'You have the right to lodge a complaint with a Polish supervisory authority if you suppose that the processing of your personal data violates the law of the General Data Protection Regulation of 27 April 2016.',
  ]
}
</script>

<style lang="scss">
// @import "~assets/css/colors.scss";
// @import "~assets/css/vars.scss";

.terms-form {
  .checkbox input[type='checkbox']:checked + span,
  .checkbox input[type='radio']:checked + span,
  .radio input[type='checkbox']:checked + span,
  .radio input[type='radio']:checked + span {
    font-weight: 400;
  }
  .checkbox {
    margin-bottom: 0;
  }
  p.text-danger {
    margin-top: 0;
    font-size: 14px;
    text-align: left;
  }
}
</style>

<style scoped lang="scss">
.checkbox {
  input[type='checkbox'] + span {
    font-size: 12px;
    color: #757575;

    &::before {
      line-height: 15px;
    }
  }
}
</style>
